<template>
  <div>
    <v-list-item-title class="mt-3 mb-1 font-weight-medium text-center">{{  $t("LoggedArea.Links.PopUp.MGM.title")  }}</v-list-item-title>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>
          {{  $t("LoggedArea.Links.PopUp.MGM.subtitle1")  }}
          <span class="font-weight-medium">2 {{  $t("LoggedArea.Links.PopUp.MGM.coins")  }}</span>
        </v-list-item-subtitle>
        <v-list-item-subtitle class="mt-3">
            {{  $t("LoggedArea.Links.PopUp.MGM.subtitle2")  }}
          <span class="font-weight-medium">{{coins || 0}} {{  $t("LoggedArea.Links.PopUp.MGM.coins")  }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <!-- EXPLANATION ON HOW TO GET COINS -->

    <v-list-item-title class="mt-3 mb-1 font-weight-medium text-center"> {{  $t("LoggedArea.Links.PopUp.MGM.title2")  }}</v-list-item-title>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>{{  $t("LoggedArea.Links.PopUp.MGM.question1")  }}</v-list-item-title>
        <v-list-item-subtitle two-line>{{  $t("LoggedArea.Links.PopUp.MGM.answer1")  }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card width="90%" outlined class="mx-auto mt-2" elevation="2">
      <v-list-item-title
        class="mt-3 mb-1 font-weight-medium text-center"
      >{{  $t("LoggedArea.Links.PopUp.MGM.title3")  }}</v-list-item-title>
      <v-list>
        <v-list-item class="p-0">
          <!-- <v-list-item-content class="body-2">Your LINK:</v-list-item-content> -->
          <v-list-item-content
            width="90%"
            class="caption"
            style="overflow-x:hidden; white-space: nowrap;"
          >
            <input id="codeURL" type="text" :value="url" readonly />
          </v-list-item-content>
          <v-list-item-content class="ml-2">
            <v-btn
              class
              outlined
              small
              style="height:20px;"
              color="purple darken-4 text--darken-4"
              @click="copyCode('#codeURL')"
            >
             <span style="font-size:xx-small;" v-if="!copy">{{BtnCopy}}</span>
             <v-icon small v-else>mdi-check</v-icon>
            
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { auth, analytics } from "@/config/firebaseConfig";
export default {
  data() {
    return {
      code: auth.currentUser.uid,
      url: process.env.VUE_APP_USER_URL + `signup?mgm=${auth.currentUser.uid}`,
      BtnCopy: this.$t("LoggedArea.Links.PopUp.MGM.btnCopy"),
      copy:false
    };
  },
  computed:{
    coins(){
      return this.$store.state.coins
    }
  },
  methods: {
    copyCode(id) {
      const link = document.querySelector(id);
      link.select();
      document.execCommand("SelectAll");
      document.execCommand("Copy", false, null);
      this.copy = true;
      setTimeout(()=>{
        this.copy=false;
      }, 3000)
      analytics.logEvent("MGM_CpyLink")
    },
  },
};
</script>

<style>
#codeURL {
  background-color: #f5f3f3;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
}
.v-list-item__subtitle, .v-list-item__title {
    white-space: break-spaces !important;
}
</style>